// extracted by mini-css-extract-plugin
export default {"mainBody":"index_mainBody_-96OL"};